import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

/**
 * libs
 */
import { OwlOptions } from 'ngx-owl-carousel-o';

/**
 * enums
 */
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';

/**
 * interfaces
 */
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

/**
 * services
 */
import { GlobleService } from 'src/app/core/services/globle.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

@Component({
  selector: 'app-related-advertisements',
  templateUrl: './related-advertisements.component.html',
  styleUrls: ['./related-advertisements.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RelatedAdvertisementsComponent implements OnInit {

  /************  Inputs  ************/
  /**
   * advertisementData
   * @description Advertisement Data
   */
  @Input({ alias: 'advertisementData', required: true }) public AdvertisementData: IAdvertisementResponse = null;  

  /************  fields  ************/
  /**
   * @description list of Advertisement
   */
  public Advertisements: IAdvertisementResponse[] = [];

  /**
   * IsLoading
   * @description loading RelatedAdvertisements result
   */
  public IsLoading: boolean = false;

  /**
   * OwlOption
   */
  public OwlOption: OwlOptions = {
    rtl: true,
    margin: 20,
    dots: true,
    autoWidth: false,
    skip_validateItems: true,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      991: {
        items: 3
      }
    }
  }   


  /**
   *
   */
  constructor(
    private _g: GlobleService,
    private _api: ApiResponseService,
  ) {}
  

  public ngOnInit(): void {
    
    /**
     * init
     */
    this._getRelatedAdvertisements();

  }

  /************  Methods  ************/
  /**
   * _getRelatedAdvertisements
   */
  private _getRelatedAdvertisements() {

    // ES6 destructuring
    const { id, category, subCategory} = this.AdvertisementData;

    // get CorrectUserId
    const userId  = this._g.CorrectUserId ? this._g.CorrectUserId : ''

    /**
     * config
     */
    const params = {
      id,
      userId,
      limit: 8,
      related: true,
      category: category.id,
      subCategory: subCategory.id,
      [RANDOM_VALUE.loader]: true,
    }


    // start loading
    this.IsLoading = true;
    
    /**
     * 
     */
    this._api
      .AdsWithOutPagination({params})
      .subscribe({
        next: res => {

          /**
           * 
           */
          this.Advertisements = res;

          /**
           * stop loading
           */
          this.IsLoading = false;

        },
        error: _ => this.IsLoading = false
      })

  }  

}
